import React from 'react'
import { Stack, SimpleTabs } from '@/components/lib'
import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'

import List from './List'
import Automatic from './Automatic'

export default function Queries () {
  const { trial } = useStore()
  useTitle('Queries', trial)

  return (
    <Stack gap={5}>
      <SimpleTabs
        lazyMount
        tabs={[
          { title: 'Current queries', content: <List /> },
          { title: 'Automatic queries', content: <Automatic /> }
        ]}
      />
    </Stack>
  )
}
